import Vue from 'vue'
import App from './App.vue'
import Store from "./commons/store";
import router from './commons/router';
import Vuex from 'vuex'
import store from './store/store'
import Antd from 'ant-design-vue';
import echarts from 'echarts';
import moment from "moment";
import http from "./commons/http";
import PortalVue from 'portal-vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import vueBus from './commons/vueBus';

import './styles/iconfons/iconfont.css'
import './styles/iconfons/iconfont.js'

import './components';
import './styles/index.less';
import './styles/components.less';
import 'moment/locale/zh-cn';
import vcolorpicker from 'vcolorpicker';
import Steps from "./components/steps.vue"
import Stepd from "./components/stepd.vue"
import md5 from 'js-md5';

import VueI18n from 'vue-i18n'
import LangENUS from './commons/en-us'
import LangZHCN from './commons/zh-cn'
Vue.use(VueI18n)
Vue.use(vueBus);

import htmlToPdf from './commons/htmlToPdf'
Vue.use(htmlToPdf)

const i18n = new VueI18n({
  // locale: 'zh-cn',
  locale: localStorage.getItem('localeval') || 'zh-cn',
  messages: {
    'en-us': LangENUS,
    'zh-cn': LangZHCN
  }
})

import Utils from './utils/index.js';
Vue.prototype.utils=Utils;

import { message } from 'ant-design-vue'
Vue.prototype.$message = message;
message.config({
  duration: 2,// 持续时间
  maxCount: 1,
  top: `50%`, // 到页面顶部距离
})
// message.config({ top: 300 })
Vue.prototype.$md5 = md5;

moment.locale("zh-cn");

Vue.config.productionTip = false
Vue.prototype.$message = Antd.message;
Vue.prototype.$echarts = echarts;
Vue.prototype.$http = http;
Vue.prototype.$moment = moment;

Vue.component("s-steps", Steps);
Vue.component("s-stepd", Stepd);
Vue.use(ElementUI);
Vue.use(Antd);
Vue.use(PortalVue);
Vue.use(vcolorpicker);
Vue.use(Store);

router.afterEach((to,from,next)=>{
　　window.scrollTo(0,0)
})

import { Loading } from 'element-ui'
let loading=''
Vue.prototype.$openLoading = function() {
  loading = this.$loading({           // 声明一个loading对象
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  // return loading;
}
Vue.prototype.$openLoadingHide = function() {
  loading.close()
  // return loading;
}

import common from './commons/common.js'
Vue.prototype.$common = common

Vue.directive('RegExp', {
  inserted(el,bindle) {
    const {value} = bindle
    const regList ={
		REG_ZERO_INTEGER:common.REG_ZERO_INTEGER_FUN,
		special:common.special,
		EnglishOnly:common.EnglishOnly,
		Remove_Chinese_Symbols:common.RemoveChineseAndChineseSymbols
    }
    const reg = regList[value]|| value
    if(reg){
      el.addEventListener('input', (e) => {
        let value = e.target.value;
        // 将输入值转换为数字类型
        e.target.value = reg(value)
        e.target.dispatchEvent(new Event('input')); // 更新v-model绑定的值
      });
    }
  }
});

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')